import React from 'react';
import * as R from 'ramda';
import { components } from 'react-select';
import styled, { css } from 'styled-components';
// helpers
import * as G from '../../../helpers';
//////////////////////////////////////////////////

const FloatingSelectLabel = styled.span`
  top: 0;
  left: 0;
  z-index: 2;
  font-size: 12px;
  overflow: hidden;
  line-height: 14px;
  position: absolute;
  white-space: nowrap;
  pointer-events: none;
  text-overflow: ellipsis;
  transform-origin: top left;
  max-width: calc(100% - 42px);
  transform: translate(8px, 9px) scale(1);
  color: ${() => G.getTheme('colors.darkGrey')};
  transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;

  ${({ $shouldFloat }) => $shouldFloat && css`
    padding: 0 5px;
    max-width: calc(133% - 32px);
    transform: translate(4px, -6px) scale(0.75);
    color: ${G.getTheme('colors.azure')};
    background-color: ${G.getTheme('colors.white')};
  `}
`;

const IndicatorSeparator = () => null;

const FloatingSelectControl = (props) => {
  const {
    children,
    hasValue,
    isFocused,
    selectProps,
  } = props;

  const shouldFloat = R.or(isFocused, hasValue);

  return (
    <components.Control {...props}>
      <FloatingSelectLabel
        $shouldFloat={shouldFloat}
        data-floating={shouldFloat}
        title={selectProps.floatingLabel}
      >
        {selectProps.floatingLabel}
      </FloatingSelectLabel>
      {children}
    </components.Control>
  );
};

const FloatingSelectPlaceholder = (props) => {
  const { isFocused, selectProps } = props;

  return (
    <components.Placeholder {...props}>
      {G.ifElse(isFocused, selectProps.focusedPlaceholder, '')}
    </components.Placeholder>
  );
};

export const getTitleFilterSelectComponents = (useFloatingLabel) => {
  const floatingComponents = G.ifElse(
    G.isTrue(useFloatingLabel),
    {
      Control: FloatingSelectControl,
      Placeholder: FloatingSelectPlaceholder,
    },
    {},
  );

  return {
    ...floatingComponents,
    IndicatorSeparator,
  };
};

export const getTitleFilterSelectControlStyles = (baseStyles, state, useFloatingLabel) => {
  const baseControlStyles = {
    ...baseStyles,
    minHeight: 32,
    borderRadius: 4,
    borderColor: G.getTheme('colors.borderGray'),
  };

  if (G.isFalse(useFloatingLabel)) return baseControlStyles;

  const shouldHighlight = R.or(state.isFocused, state.hasValue);

  const borderColor = G.ifElse(
    shouldHighlight,
    G.getTheme('colors.azure'),
    G.getTheme('colors.borderGray'),
  );

  return {
    ...baseControlStyles,
    boxShadow: 'none',
    ':hover': { borderColor },
    border: `${G.ifElse(shouldHighlight, '1.5px', '1px')} solid ${borderColor}`,
  };
};
